var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addnote_wrap" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("el-input", {
        attrs: {
          type: "textarea",
          placeholder: "在此记录你的想法...",
          maxlength: "2000",
          "show-word-limit": "",
          resize: "none"
        },
        nativeOn: {
          keydown: function($event) {
            return _vm.listen($event)
          }
        },
        model: {
          value: _vm.noteCont,
          callback: function($$v) {
            _vm.noteCont = $$v
          },
          expression: "noteCont"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "noteCheck" },
        [
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.checked,
                callback: function($$v) {
                  _vm.checked = $$v
                },
                expression: "checked"
              }
            },
            [_vm._v("公开")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "btn" }, [
        _c(
          "a",
          {
            staticClass: "btn_itme btn_can",
            on: {
              click: function($event) {
                return _vm.cancel()
              }
            }
          },
          [_vm._v("取 消")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn_itme btn_send",
            on: {
              click: function($event) {
                return _vm.editorNote()
              }
            }
          },
          [_vm._v("保 存")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top" }, [
      _c("span", [_vm._v("*")]),
      _vm._v("笔记内容        \n\t")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2bec0fe3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bec0fe3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/note/editorNote.vue
// module id = null
// module chunks = 